import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import Login from '../Logins/Login';
import Register from '../Logins/Register';
import ForgotPassword from '../Logins/ForgotPassword';
import ProtectedRoute from '../ProtectedRoute';
import MapPage from '../../Pages/MapPage';
import SiteDetailsPage from '../../Pages/SiteDetailsPage';
import CadastrosPage from '../../Pages/CadastrosPage';
import OperacaoPage from '../../Pages/OperacaoPage';
import DashboardMeteorologico from '../../Pages/DashboardMeteorologico';
import PiadseMarketPage from '../../Pages/PiadseMarketPage';
import AnalisesPage from '../../Pages/AnalisesPage';
import ConfiguracoesPage from '../../Pages/ConfiguracoesPage';
import UserManagementPage from '../../Pages/UserManagementPage';
import AccountManagementPage from '../../Pages/AccountManagementPage';
import ChatPage from '../../Pages/ChatPage';

const AppRoutes = () => {
    const { user } = useAuth();
    const roles = user?.role?.split(',').map(role => role.trim()) || [];
    const isAdmin = roles?.includes("ROLE_ADMIN") || roles?.includes("ROLE_DEV") || roles?.includes("ADMIN");

    return (
        <Routes>
            <Route path="/" element={<Navigate to={user ? '/mapa-dos-sites' : '/login'} replace />} />

            {/* Rotas de autenticacao */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />

            <Route
                path="/gerenciar-usuarios"
                element={
                    <ProtectedRoute>
                        {isAdmin ? <UserManagementPage /> : <Navigate to="/mapa-dos-sites" replace />}
                    </ProtectedRoute>
                }
            />

            <Route
                path="/gerenciar-conta"
                element={
                    <ProtectedRoute>
                        <AccountManagementPage />
                    </ProtectedRoute>
                }
            />

            {/* Rotas protegidas */}
            <Route
                path="/mapa-dos-sites"
                element={
                    <ProtectedRoute>
                        <MapPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/site/:id"
                element={
                    <ProtectedRoute>
                        <SiteDetailsPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/cadastros"
                element={
                    <ProtectedRoute>
                        <CadastrosPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/painel-operacao"
                element={
                    <ProtectedRoute>
                        <OperacaoPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/Dados-Meteorologicos"
                element={
                    <ProtectedRoute>
                        <DashboardMeteorologico />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/piadse-mercado"
                element={
                    <ProtectedRoute>
                        <PiadseMarketPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/analises"
                element={
                    <ProtectedRoute>
                        <AnalisesPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/configuracoes"
                element={
                    <ProtectedRoute>
                        <ConfiguracoesPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/chat"
                element={
                    <ProtectedRoute>
                        <ChatPage />
                    </ProtectedRoute>
                }
            />

            {/* Fallback */}
            <Route path="*" element={<Navigate to={user ? '/mapa-dos-sites' : '/login'} replace />} />
        </Routes>
    );
};

export default AppRoutes;
